const initialReviewsState = {
    reviews: undefined,
    loading: true,
    loading_more: false
}
const preferredManageReviewsInitialState = {
    preferred_manage_reviews: localStorage.getItem('preferredManageReviews') ?? 'regular'
}
console.log(localStorage.getItem('preferredManageReviews'))
export const getReviews = (state = initialReviewsState, action) => {
    switch(action.type){
        case 'GET_REVIEWS':
            const currentReviews = state.reviews || { data: [], links: {}, meta: {} };
            const newReviews = action.payload.data;
            const existingReviewIds = new Set(currentReviews.data.map(review => review.id));
            const filteredNewReviews = newReviews.filter(review => !existingReviewIds.has(review.id));
            
            return {
                ...state,
                reviews: {
                    ...currentReviews,
                    data: [...currentReviews.data, ...filteredNewReviews],
                    links: action.payload.links,
                    meta: action.payload.meta,
                    reviews_count: action.payload.reviews_count
                },
                loading: false,
                loading_more: false
            }
        case 'SET_REVIEWS':
            return {
                ...state,
                reviews: {
                    data: action.payload.data,
                    links: action.payload.links,
                    meta: action.payload.meta,
                    reviews_count: action.payload.reviews_count
                },
                loading: false,
                loading_more: false
            }
        case 'UPDATE_REVIEWS_ISREAD':
            const {review_id, status} = action.payload
            return{
                ...state,
                reviews: {
                    ...state.reviews,
                    data: state?.reviews.data?.map(review => {
                        const updatedReview = review.id === review_id
                        if(updatedReview){
                            return {...review, is_read: status}
                        }
                        return review;
                    })
                }
            }
        case 'UPDATE_REVIEW_TAGS': {
            const { reviewId, tags } = action.payload;

            if (!state.reviews?.data) return state;

            return {
                ...state,
                reviews: {
                    ...state.reviews,
                    data: state.reviews.data.map(review =>
                        review.id === reviewId ? { ...review, tags } : review
                    )
                }
            };
        }
        case 'LOADING_MORE':
            return{
                ...state,
                loading: false,
                loading_more: true
            }
        case 'LOADING_TABLES':
            return{
                ...state,
                loading: true,
                loading_more: false
            }
        case 'CLEAR_LOADING_TABLES':
            return{
                ...state,
                loading: false,
                loading_more: false
            }
        case 'TOGGLE_PINNED_STATUS':
            const { id, pin } = action.payload;
        
            const updatedReviews = state.reviews?.data?.map(review => {
                if (review.id === id) {
                    return {
                        ...review,
                        is_pinned: pin
                    };
                }
                return review;
            });

            return {
                ...state,
                reviews: {
                    ...state.reviews,
                    data: [...(updatedReviews ?? [])]
                }
            };
        case 'UPDATE_REVIEW_UNREAD':{
            const updatedReviews = state.reviews?.data?.map(review => {
                if (review.id === action.payload.reviewId) {
                    return {
                        ...review,
                        unread: review.unread + 1
                    };
                }
                return review;
            });
            return {
                ...state,
                reviews: {
                    ...state.reviews,
                    data: [...(updatedReviews ?? [])]
                }
            };
        }
        case 'REPLIED_STATUS': {
            const { rev_id, status } = action.payload;
            const updatedRepliedReviews = state.reviews?.data?.filter(review => {
                    if (review.id === rev_id && status === 'not-responded') {
                        return false;
                    }
                    return true;
                }).map(review => {
                    if (review.id === rev_id && status != 'not-responded') {
                        return {
                            ...review,
                            responded: true
                        };
                    }
                    return review;
                });
        
            return {
                ...state,
                reviews: {
                    ...state.reviews,
                    data: [...(updatedRepliedReviews ?? [])]
                }
            };
        }
        case 'RESOLVED_STATUS': {
            const { rev_id, resolved } = action.payload;
            const updatedResolvedReviews = state.reviews?.data?.map(review => {
                if (review.id === rev_id) {
                    return {
                        ...review,
                        resolved: resolved
                    };
                }
                return review;
            })
            
            return {
                ...state,
                reviews: {
                    ...state.reviews,
                    data: [...(updatedResolvedReviews ?? [])]
                }
            };
        }
        case 'UPDATE_TAGS': {
            const { rev_id, tags } = action.payload;
            const updatedTagsReviews = state.reviews?.data?.map(review => {
                if (review.id === rev_id) {
                    return {
                        ...review,
                        tags: tags
                    };
                }
                return review;
            });
            
            return {
                ...state,
                reviews: {
                    ...state.reviews,
                    data: [...(updatedTagsReviews ?? [])]
                }
            };
        }
        case 'CLEAR_REVIEWS':
            return{
                ...state,
                reviews: undefined
            }
        default:
            return{
                ...state
            }
    }
}

export const getReview = (state = [], action) => {
    switch(action.type){
        case 'GET_REVIEW':
            return{
                ...state,
                review: action.payload,
            }
        case 'CLEAR_REVIEW':
            return{
                ...state,
                review: undefined,
            }
        default:
            return{
                ...state
            }
    }
}

export const getReviewsBoxes = (state = [], action) => {
    switch(action.type){
        case 'GET_REVIEWS_TOP_BOXES':
            return{
                ...state,
                reviews_boxes: action.payload,
            }
            case 'CLEAR_TOP_BOXES':
                return{
                    ...state,
                    reviews_boxes: undefined
                }
        default:
            return{
                ...state
            }
    }
}

export const getReviewsHistory = (state = [], action) => {
    switch(action.type){
        case 'GET_REVIEWS_HISTORY':
            return{
                ...state,
                history: action.payload,
                loading: false
            }
        case 'LOADING_HISTORY':
            return{
                history: undefined,
                loading: true
            }
        default:
            return{
                ...state
            }
    }
}

export const getQuickReplies = (state = [], action) => {
    switch(action.type){
        case 'GET_QUICK_REPLY':
            return{
                ...state,
                replies: action.payload,
            }
        default:
            return{
                ...state
            }
    }
}
export const getQuickReply = (state = [], action) => {
    switch(action.type){
        case 'GET_QUICK_REPLY_DETAILS':
            return{
                ...state,
                reply: action.payload,
            }
            case 'CLEAR_QUICK_REPLY_DETAILS':
                return{
                    ...state,
                    reply: undefined
                }
        default:
            return{
                ...state
            }
    }
}

export const getReviewsCoupon = (state = [], action) => {
    switch(action.type){
        case 'GET_REVIEWS_COUPON':
            return{
                ...state,
                coupons: action.payload,
            }
        case 'CLEAR_REVIEWS':
            return{
                ...state,
                coupons: undefined
            }
        default:
            return{
                ...state
            }
    }
}
export const getReviewNotes = (state = [], action) => {
    switch(action.type){
        case 'GET_REVIEW_NOTES':
            return{
                ...state,
                notes: action.payload,
            }
        case 'CLEAR_REVIEW_NOTES':
            return{
                ...state,
                notes: undefined
            }

        case 'ADD_NOTES':
            return{
                ...state,
                notes: {
                    ...state.notes,
                    notes: [...state.notes.notes, action.payload]
                }
            }
        default:
            return{
                ...state
            }
    }
}
export function getFormattedReviews(state = {}, action) {
    switch(action.type){
        case 'FORMATTED_REVIEWS':
            const convertedData = {
                pinned: [],
                byDate: []
            };
            if (action.payload) {
                action.payload.data.forEach(item => {
                    const date = item.published_at.split(' ')[0];
                    if (item.is_pinned) {
                        convertedData.pinned.push(item);
                    } else {
                        const existingEntry = convertedData.byDate.find(entry => entry.date === date);
                        if (existingEntry) {
                            existingEntry.items.push(item);
                        } else {
                            convertedData.byDate.push({
                                date: date,
                                items: [item]
                            });
                        }
                    }
                });
            }
            return {
                ...state,
                formatted_reviews: convertedData
            };
        case 'CLEAR_FORMATTED_REVIEWS':
            return{
                ...state,
                formatted_reviews: undefined
            }
        default:
            return state;
    }
}
//This is used for new page of Manage Reviews, the reason i seperated states is because the ui is different, and i dont want loading reviews at old page to the new page loaded.
//Get reviews is used for getting reiews first time, setReviews is used for infinite scroll
export const getReviewsV2 = (state = initialReviewsState, action) => {
    switch(action.type){
        case 'GET_REVIEWS_V2':
            const currentReviews = state.reviews || { data: [], links: {}, meta: {} };
            const newReviews = action.payload.data;
            const existingReviewIds = new Set(currentReviews.data.map(review => review.id));
            const filteredNewReviews = newReviews.filter(review => !existingReviewIds.has(review.id));
            
            return {
                ...state,
                reviews: {
                    ...currentReviews,
                    data: [...currentReviews.data, ...filteredNewReviews],
                    links: action.payload.links,
                    meta: action.payload.meta,
                    reviews_count: action.payload.reviews_count
                },
                loading: false,
                loading_more: false
            }
        case 'SET_REVIEWS_V2':
            return {
                ...state,
                reviews: {
                    data: action.payload.data,
                    links: action.payload.links,
                    meta: action.payload.meta,
                    reviews_count: action.payload.reviews_count
                },
                loading: false,
                loading_more: false
            }
        case 'LOADING_MORE':
            return{
                ...state,
                loading: false,
                loading_more: true
            }
        case 'LOADING_TABLES':
            return{
                ...state,
                loading: true,
                loading_more: false
            }
        case 'CLEAR_LOADING_TABLES':
            return{
                ...state,
                loading: false,
                loading_more: false
            }
        case 'CLEAR_REVIEWS':
            return{
                ...state,
                reviews: undefined
            }
        default:
            return{
                ...state
            }
    }
}
export const preferredManageReviewsReducer = (state = preferredManageReviewsInitialState, action) => {
    switch(action.type){
        case 'SET_PREFFERED_MANAGE_REVIEWS':
            return{
                ...state,
                preferred_manage_reviews: state.preferred_manage_reviews === "regular" ? "advanced" : "regular"
            }
        default:
            return{
                ...state
            }
    }
}